// extracted by mini-css-extract-plugin
export default {"span":"Projects_span__oCWEL","title":"Projects_title__tBYLF","goUp":"Projects_goUp__yQSmv","anim-goUp":"Projects_anim-goUp__-IliG"};